import { render } from "./yeji-mingxi.vue?vue&type=template&id=29db7db6&scoped=true"
import script from "./yeji-mingxi.vue?vue&type=script&lang=js"
export * from "./yeji-mingxi.vue?vue&type=script&lang=js"

import "./yeji-mingxi.vue?vue&type=style&index=0&id=29db7db6&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29db7db6"]])

export default __exports__